import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { SiteShell } from "@/components/layout/SiteShell";
import {
  parseYearSlug,
  parseMonthSlug,
  parseDateSlug,
  MONTH_SLUGS_EN_LIST,
} from "@/lib/calendar/dates";
import { translatePathToId } from "@/i18n/paths";

/**
 * Legacy `/en/<year-or-month-or-date>` URLs are now under `/en/calendar/...`.
 * 308-redirect calendar slugs (accepting either ID or EN month tokens) and
 * 404 anything else.
 */
export const Route = createFileRoute("/en/$slug")({
  loader: ({ params }) => {
    const slug = params.slug;
    const y = parseYearSlug(slug);
    if (y !== null) {
      throw redirect({ to: `/en/calendar/${y}/`, code: 308 } as any);
    }
    // Translate any ID month token to ID form, then re-emit as EN nested URL.
    // The flat /en/{slug} shape is always legacy — every successful match
    // here MUST redirect to the nested /en/calendar/... form. The new
    // location can never equal the request, so no loop is possible, but
    // we still guard defensively.
    const idForm = translatePathToId(`/${slug}`).slice(1);
    const ym = parseMonthSlug(idForm);
    if (ym) {
      const to = `/en/calendar/${ym.y}/${MONTH_SLUGS_EN_LIST[ym.m - 1]}/`;
      if (to !== `/en/${slug}`) throw redirect({ to, code: 308 } as any);
    }
    const ymd = parseDateSlug(idForm);
    if (ymd) {
      const to = `/en/calendar/${ymd.y}/${ymd.d}-${MONTH_SLUGS_EN_LIST[ymd.m - 1]}/`;
      if (to !== `/en/${slug}`) throw redirect({ to, code: 308 } as any);
    }
    throw notFound();
  },
  component: () => null,
  notFoundComponent: () => (
    <SiteShell locale="en">
      <div className="py-16 text-center">
        <h1 className="text-2xl font-bold">Page not found</h1>
      </div>
    </SiteShell>
  ),
});